import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function VerifyEmailPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { verifyEmail } = useAuth();
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("Verifying your email...");

  const token = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get("token") || "";
  }, [location.search]);

  useEffect(() => {
    const prevTheme = document.body.getAttribute("data-theme");
    document.body.setAttribute("data-theme", "cobalt");
    return () => {
      if (prevTheme) document.body.setAttribute("data-theme", prevTheme);
      else document.body.removeAttribute("data-theme");
    };
  }, []);

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      if (!token) {
        if (!cancelled) {
          setStatus("error");
          setMessage("This verification link is invalid or incomplete.");
        }
        return;
      }

      const result = await verifyEmail(token);
      if (cancelled) return;
      if (!result?.ok) {
        setStatus("error");
        setMessage(result?.error || "This verification link is invalid or expired.");
        return;
      }
      setStatus("success");
      setMessage(result?.message || "Your email is verified. You can sign in now.");
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [token, verifyEmail]);

  return (
    <div className="auth-shell">
      <div className="auth-media" aria-hidden="true">
        <video className="auth-background-video" autoPlay muted loop playsInline>
          <source src="/backgroundvideo.mp4" type="video/mp4" />
        </video>
        <div className="auth-media-overlay" />
      </div>
      <div className="auth-card glass">
        <div className="brand-block">
          <img src="/wavvy-wordmark.png" alt="Wavvy" className="brand-wordmark" />
          <p>Secure account verification in progress.</p>
        </div>

        <h2 className="auth-panel-title centered">
          {status === "loading" ? "Verifying email..." : status === "success" ? "Email verified" : "Verification failed"}
        </h2>

        <p className={status === "success" ? "auth-success-text" : "auth-helper"}>
          {message}
        </p>

        <div className="auth-form">
          <button type="button" className="primary-btn" onClick={() => navigate("/auth/login")}>
            Go to Sign In
          </button>
          {status === "error" ? (
            <button type="button" className="ghost-btn" onClick={() => navigate("/auth/check-email")}>
              Resend verification email
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
